import { styled, Typography } from '@mui/material';
import { Box } from '@mui/system';

type HideProps = {
    hide: boolean
}

export const StyledUploadAreaContainerBox = styled(Box)((props: HideProps) => {
    return {
        position: 'relative',
        transition: 'opacity linear 0.25s, z-index linear 0.25s',
        width: '100%',
        marginTop: '16px',
        zIndex: 1,
        '&:hover': {
            cursor: props.hide ? 'default' : 'pointer',
            opacity: props.hide ? 1 : 0.75,
            zIndex: props.hide ? -1 : 1,
        }
    }
})

export const StyledUploadAreaBox = styled(Box)((props: HideProps) => {
    return {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '200px',
        padding: '16px',
        transition: 'border-color linear 0.25s, background-color linear 0.25s',
        border: '2px dashed #1976d2', // Primary color
        backgroundColor: 'rgba(25, 118, 210, 0.04)',
        borderColor: props.hide ? 'transparent' : '#1976d2',
        borderRadius: '8px'
    }
})

export const StyledGreyedTypography = styled(Typography)((props: HideProps) => {
    return {
        transition: 'opacity linear 0.25s',
        opacity: props.hide ? 0 : 0.7,
        fontSize: '0.9rem',
        color: 'text.secondary'
    }
})

export const StyledNormalTypography = styled(Typography)((props: HideProps) => {
    return {
        transition: 'opacity linear 0.25s',
        opacity: props.hide ? 0 : 1
    }
})

export const StyledIconBox = styled(Box)((props: HideProps) => {
    return {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        transition: 'opacity linear 0.25s',
        opacity: props.hide ? 0 : 1,
        color: '#1976d2',
        marginBottom: '8px'
    }
})

export const StyledSpinnerBox = styled(Box)((props: HideProps) => {
    return {
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        position: 'absolute',
        transition: 'opacity linear 0.25s, z-index linear 0.25s',
        opacity: props.hide ? 0 : 1,
        pointerEvents: 'none'
    }
})
